import { useQuery } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedQueryOptions } from 'queries/types';
import { throwResponseError } from 'queries/utils';
import isOkResponse from 'utils/is-ok-response';

export function useSearch<TData = Api.V3.Search.Search.Response>(
    payload: Api.V3.Search.Search.Payload,
    options?: UseExposedQueryOptions<Api.V3.Search.Search.Response, Error, TData>
) {
    const notify = useNotify();
    return useQuery<Api.V3.Search.Search.Response, Error, TData>({
        ...options,
        queryKey: Api.V3.Search.Search.QueryKey(payload),
        queryFn: async () => {
            try {
                const response = await new RequestAgent().public.post(Api.V3.Search.Search.Endpoint(), {
                    body: payload
                });

                if (isOkResponse(response)) {
                    return response.data;
                } else {
                    throwResponseError(response);
                }
            } catch (error) {
                notify.openNotification({ level: 'error', message: error.message });
                throw error;
            }
        }
    });
}
